<template>
  <div class="overflow-hidden">
    <div class="text-center">
      <stormy-simple-segmented-control
        v-model="selectedItem"
        class="text-sm mx-auto m-3"
      >
        <stormy-simple-segmented-control-item
          name="base"
          label="Stammdaten"
        />
        <stormy-simple-segmented-control-item
          label="Details"
          name="details"
        />
      </stormy-simple-segmented-control>
    </div>
    <div class="">
      <component :is="component" />
    </div>
  </div>
</template>
<script setup>
import { computed, ref } from 'vue'
import ObuBookingContractorMaskBase from './ObuBookingContractorMaskBase.vue'
import ObuBookingContractorMaskDetails from './ObuBookingContractorMaskDetails.vue'

const selectedItem = ref('base')

const component = computed(() => {
  switch (selectedItem.value) {
    case 'details':
      return ObuBookingContractorMaskDetails
    default:
      return ObuBookingContractorMaskBase
  }
})
</script>
